import React, { useEffect, useState } from "react";
import "../App.css";
import { gameData } from "../utils/gameData";
import { Link } from "react-router-dom";
import ReactGA from 'react-ga4'
import { captureEvent } from "../services/analytics/eventCapture";

const GameHome = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/gameHome", title: "Game | Chimera | Euler Motors" });
    setLoading(true);
  }, []);

  setTimeout(function () {
    setLoading(false);
  }, 2000);

  return (
    <div className="w-full h-full">
      {loading ? (
        <div className="w-full h-full flex flex-row justify-center items-center bg-black text-5xl font-bold text-white bg-[#202124]">
          <div className="spinner"></div>
        </div>
      ) : (
        <div className="bg-[#202124] text-white scroll-container gamePageText w-full h-full overflow-y-auto overflow-x-hidden flex flex-col gap-x-8 px-5 py-5 gap-y-5">
          <div className='text-[32px] font-medium'>Games</div>
          <div className="w-full scroll-content grid  2xl:grid-cols-6 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-x-5 gap-y-5">
            {gameData?.filter((game) => !game?.isPortrait)?.map((game) => (
              <Link
                to={`game/${game?.code}`}
                onClick={() => captureEvent('Game', 'Game_Played', game?.name?.en)}
                className=" w-full h-fit flex flex-col items-center justify-center gap-y-5 rounded-xl"
              >
                <img
                  src={game?.assets?.cover}
                  alt={`game${game?.code}`}
                  className="rounded-xl w-full h-[250px]"
                />
                <div className="text-white text-xl font-bold pb-2">
                  {game?.name?.en}
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default GameHome;
